import gql from 'graphql-tag';

const LOGIN_MUTATION = gql`
  mutation Mutation($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      token
      user {
        _id
        emails {
          verified
          address
        }
        roles
        user_role
        username
        profile {
          name
          region
          profession
          imageUrl
        }
        createdAt
        customer
        countryCode
      }
    }
  }
`;

export default LOGIN_MUTATION;
